import { Flex, Text } from "@chakra-ui/react";
import { CircleArrowLeftIcon } from "../../components/icons/CircleArrowLeftIcon";
import { CircleArrowRightIcon } from "../../components/icons/CircleArrowRightIcon";

interface FeedOnboardingOverlayProps {
  // 'r' (right-to-left) flips the arrow so it points in the actual page-
  // advance direction. Anything else is treated as LTR.
  readingDirection?: string;
}

/**
 * "Swipe to read" hint that sits centered inside the active comic feature
 * card. Purely presentational — the parent decides when to mount it (only on
 * the deck's starting slot) and the user's first page-flip naturally hides
 * it by changing activePage.
 *
 * pointerEvents: none lets all gestures (swipe, tap, scroll) pass through
 * to the underlying card so the hint never blocks normal navigation.
 */
export function FeedOnboardingOverlay({
  readingDirection,
}: FeedOnboardingOverlayProps) {
  const isRtl = readingDirection === "r";
  const ArrowIcon = isRtl ? CircleArrowLeftIcon : CircleArrowRightIcon;

  return (
    <Flex
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      direction="column"
      align="center"
      gap={3}
      px={6}
      py={5}
      bg="rgba(0, 0, 0, 0.78)"
      backdropFilter="blur(6px)"
      borderRadius="2xl"
      boxShadow="0 8px 32px rgba(0, 0, 0, 0.55)"
      zIndex={1700}
      pointerEvents="none"
      sx={{
        animation: "feedOnboardFade 200ms ease-out",
        "@keyframes feedOnboardFade": {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      <ArrowIcon width="56px" height="56px" color="orange.400" />
      <Text
        color="white"
        fontSize="md"
        fontWeight="bold"
        letterSpacing="0.04em"
      >
        Swipe to read
      </Text>
    </Flex>
  );
}
